var api = "https://api.qingcigame.com/jpweb";
let swiperInstances = {};
var colEmail = '';
var emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;

var obj = {
    index: function() {
        this.preloading(); // 预加载
        this.bind(); // 所有绑定事件
        this.getUrl(); // 获取链接
    },
    // 图片资源预加载
    preloading: function() {
        //图片预加载
        var queue = new createjs.LoadQueue();
        var load = layer.load(2, { shade: [0.1, '#fff'] });
        queue.on("progress", function(e) {
            // //加载中的进度
        }, this);
        queue.on("complete", function(e) {
            layer.close(load);
            $('.index').addClass('index-show');
            obj.indexSwiper();
            obj.swiperList();
        }, this);
        queue.loadManifest([
            //加载图片，不包括后台的       
            '/3rd-anniversary-718/images/pc/index_bg-3103078ed2.png',
            '/3rd-anniversary-718/images/pc/2/index_bg-4fa97de480.png',
            '/3rd-anniversary-718/images/pc/3/index_bg-cbad78926a.png',
            '/3rd-anniversary-718/images/pc/index_title-6021a1ae90.png',
            '/3rd-anniversary-718/images/pc/2/shape_bg-215b5698ad.png',
            '/3rd-anniversary-718/images/pc/2/version_bg-8faa33ac87.png',
            '/3rd-anniversary-718/images/pc/3/content_01_bg-38c8578024.png',
            '/3rd-anniversary-718/images/pc/3/content_02_bg-57c99225b1.png',
            '/3rd-anniversary-718/images/pc/3/content_03_bg-c399c0d96b.png',
            '/3rd-anniversary-718/images/pc/4/content_01_bg-53febb54ab.png',
            '/3rd-anniversary-718/images/pc/4/content_02_bg-86d221b260.png',
        ]);
    },
    // 首页轮播
    indexSwiper: function() {
        var mySwiper = new Swiper('.swiper-container-h', {
            direction: 'vertical',
            slidesPerView: 'auto',
            spaceBetween: 0,
            mousewheel: true,
            resistanceRatio: 0,
            touchMoveStopPropagation: false,
            touchStartForcePreventDefault: true,
            on: {
                init: function() {
                    swiperAnimate(this);
                },
                slideChangeTransitionEnd: function() {
                    swiperAnimate(this);
                },
            },
        });
    },
    swiperList: function() {
        const swipers = [
            { name: 'roleSwiper', selector: '.swiper-container-role', next: '.swiper-button-next', prev: '.swiper-button-prev' },
            { name: 'shapeSwiper', selector: '.swiper-container-shape', next: '.swiper-button-next2', prev: '.swiper-button-prev2' },
            { name: 'evolutionSwiper', selector: '.swiper-container-evolution', next: '.swiper-button-next3', prev: '.swiper-button-prev3' },
            { name: 'lighthouseSwiper', selector: '.swiper-container-lighthouse', next: '.swiper-button-next4', prev: '.swiper-button-prev4' },
            { name: 'branchSwiper', selector: '.swiper-container-branch', next: '.swiper-button-next5', prev: '.swiper-button-prev5' },
            { name: 'avengersSwiper', selector: '.swiper-container-avengers', next: '.swiper-button-next6', prev: '.swiper-button-prev6' },
            { name: 'treasureSwiper', selector: '.swiper-container-treasure', next: '.swiper-button-next7', prev: '.swiper-button-prev7' }
        ];

        // 确保全局Swiper实例管理对象存在
        if (typeof swiperInstances === 'undefined') {
            window.swiperInstances = {};
        }

        swipers.forEach(function(item) {
            const $container = $(item.selector);

            if ($container.length > 0) {
                if (!swiperInstances[item.name]) {
                    swiperInstances[item.name] = new Swiper(item.selector, {
                        slidesPerView: 1,
                        loop: true,
                        navigation: {
                            nextEl: item.next,
                            prevEl: item.prev
                        }
                    });
                }
            }
        });
    },
    getUrl: function() {
        $.ajax({
            url: api + "/index",
            type: "GET",
            xhrFields: {
                withCredentials: true
            },
            success: function(json) {
                if (json.code == 200) {
                    var url = json.data.articleList.ulr;
                    // url地址
                    $('.app-btn , .ios-btn').attr('href', url[0].get_url); // App_Store
                    $('.google-btn').attr('href', url[1].get_url); // Google_Play
                    var official_url = 'https://snail.qcplay.co.jp/index.html?from=special';
                    $('.official-btn').attr('href', official_url); // 官网

                    // 下载链接
                    if (navigator.userAgent.match(/(iPhone|iPod|ios)/i)) {
                        $('.download-btn').attr('href', url[0].get_url); // App_Store
                    } else {
                        $('.download-btn').attr('href', url[1].get_url); // Google_Play
                    }

                    // 社媒链接
                    $('.twitter-btn').attr('href', url[2].get_url); // twitter
                    $('.discord-btn').attr('href', url[9].get_url); // Discord
                    $('.line-open-chat-btn').attr('href', url[8].get_url); // open_chat
                    var youtube_url = 'https://www.youtube.com/@%E5%85%AC%E5%BC%8F%E6%9C%80%E5%BC%B7%E3%81%A7%E3%82%93%E3%81%A7%E3%82%93';
                    $('.youtube-btn').attr('href', youtube_url); // youtube
                    $('.line-btn').attr('href', url[3].get_url); // LINE
                    $('.fb-btn').attr('href', url[4].get_url); // Facebook
                } else {
                    layer.msg("サーバーに接続できません", { time: 2000 });
                }
            },
            error: function() {
                layer.msg("サーバーに接続できません", { time: 2000 });
            },
            complete: function() {
                // layer.close(index);
            }
        })
    },
    postEmail: function() {
        console.log("email: ", colEmail);

        $.ajax({
            url: "https://api.qingcigame.com/sea/japan/email/index",
            type: "POST",
            xhrFields: {
                withCredentials: true
            },
            data: {
                jp_email: colEmail
            },
            success: function(json) {
                if (json.code == 200) {
                    $('.success-popup').fadeIn();
                    colEmail = '';
                    $('.email-box input').val('');
                    $('.confirm-btn').addClass('unClick');
                } else {
                    layer.msg("サーバーに接続できません", { time: 2000 });
                }
            },
            error: function() {
                layer.msg("サーバーに接続できません", { time: 2000 });
            },
            complete: function() {
                // layer.close(index);
            }
        })
    },
    bind: function() {
        $('.monitor-btn').on('click', function() {
            var mon_btn = $(this).attr('data-event');
            obj.countNum(mon_btn);
        })

        var checkData = false;
        let hasCheckedPrivacy = false; // 是否勾选隐私政策
        let countdownTimer = null; // 用于取消倒计时

        // egg-box → 弹出第九国度弹窗
        $('.egg-box').click(function(event) {
            obj.openPrevent();
            $('.secret-popup').fadeIn();
        });

        // “我必出发”按钮 → 弹出 email 弹窗1
        $('.must-btn').click(function(event) {
            $('.email-popup-1').fadeIn();
            $('.secret-popup').fadeOut();
        });

        // “我知道了”按钮 → 弹出 email 弹窗2
        $('.got-btn').click(function(event) {
            $('.email-popup-2').fadeIn();
            $('.secret-popup').fadeOut();
        });

        // 邮箱提交操作（两个弹窗共用）
        $('.email-popup-1 .confirm-btn , .email-popup-2 .confirm-btn').click(function(event) {
            colEmail = $(this).closest('.popup').find('.email-box input').val().trim();

            if (!checkData) {
                $('.privacy-popup').fadeIn();
                startCountdownIfNotChecked();
            } else {
                if (colEmail === '') {
                    $('.error-popup').fadeIn();
                } else {
                    if (!emailRegex.test(colEmail)) {
                        return layer.msg("メールボックスのフォーマットが正しくありません", { time: 2000 });
                    }
                    $('.email-popup-1 , .email-popup-2 , .privacy-popup').fadeOut();
                    obj.postEmail();
                }
            }
        });

        // 隐私弹窗勾选框
        $('.check-box').on('click', function() {
            var $btn = $(this).find('.check-btn');
            $btn.toggleClass('checked');
            checkData = $btn.hasClass('checked');

            // 只要有一次勾选过，就标记
            if ($btn.hasClass('checked')) {
                hasCheckedPrivacy = true;
            }
        });

        // 隐私弹窗 “确认” 按钮
        $('.privacy-popup .confirm-btn').on('click', function() {
            if (!$('.check-btn').hasClass('checked')) {
                var $check = $('.check-box');
                $check.addClass('shake');

                setTimeout(function() {
                    $check.removeClass('shake');
                }, 400);
                return;
            }

            // 获取当前页面上仍显示的 email 弹窗中的 input 值
            var $activeEmailPopup = $('.email-popup-1:visible, .email-popup-2:visible');
            colEmail = $activeEmailPopup.find('.email-box input').val().trim();

            if (!colEmail) {
                $('.error-popup').fadeIn();
                $('.privacy-popup').fadeOut();
            } else {
                $('.email-popup-1 , .email-popup-2 , .privacy-popup').fadeOut();
                obj.postEmail();
            }
        });

        // 倒计时函数（只有第一次弹出且未勾选触发）
        function startCountdownIfNotChecked() {
            const $checkBox = $('.check-box');
            const $checkBtn = $checkBox.find('.check-btn');
            const $confirmBtn = $('.privacy-popup .confirm-btn');
            const $sendText = $('.send-text');

            // 已有勾选记录，跳过
            if (hasCheckedPrivacy) {
                $checkBox.removeClass('disabled');
                $sendText.attr('class', 'send-text send');
                return;
            }

            // 未勾选 → 启用倒计时
            if (!$checkBtn.hasClass('checked')) {
                let count = 5;

                // 禁止勾选，置灰
                $checkBox.addClass('disabled');
                $confirmBtn.addClass('disabled');
                $sendText.attr('class', 'send-text sec-5');

                countdownTimer = setInterval(function() {
                    count--;

                    if (count > 0) {
                        $sendText.attr('class', 'send-text sec-' + count);
                    } else {
                        clearInterval(countdownTimer);
                        countdownTimer = null;
                        $sendText.attr('class', 'send-text send');
                        $checkBox.removeClass('disabled');
                        $confirmBtn.removeClass('disabled');
                    }
                }, 1000);
            }
        }

        // ✅ 隐私 “关闭” 按钮 → 关闭时清除倒计时
        $('.privacy-popup .close-btn').click(function() {
            $('.privacy-popup').fadeOut();

            if (countdownTimer) {
                clearInterval(countdownTimer);
                countdownTimer = null;
            }

            setTimeout(function() {
                // 恢复样式
                const $checkBox = $('.check-box');
                const $confirmBtn = $('.privacy-popup .confirm-btn');

                $checkBox.removeClass('disabled');
                $confirmBtn.removeClass('disabled');

                if (!hasCheckedPrivacy && !$('.check-btn').hasClass('checked')) {
                    $('.send-text').attr('class', 'send-text sec-5');
                }
            }, 200);
        });

        $('.secret-popup .close-btn').click(function(event) {
            obj.closePrevent();
            $('.secret-popup').fadeOut();
        });

        $('.email-popup-1 .close-btn').click(function(event) {
            obj.closePrevent();
            $('.email-popup-1').fadeOut();
            $('.email-popup-1 .email-box input').val('');
        });

        $('.email-popup-2 .close-btn').click(function(event) {
            obj.closePrevent();
            $('.email-popup-2').fadeOut();
            $('.email-popup-2 .email-box input').val('');
        });

        $('.success-popup .close-btn').click(function(event) {
            obj.closePrevent();
            $('.success-popup').fadeOut();
        });

        $('.error-popup .close-btn').click(function(event) {
            $('.error-popup').fadeOut();
            $('.privacy-popup').fadeOut();
        });

        // 手动打开隐私 → 同样启动倒计时机制
        $('.privacy-btn').click(function(event) {
            $('.privacy-popup').fadeIn();
            startCountdownIfNotChecked();
        });

        $('.privacy-popup .close-btn').click(function(event) {
            $('.privacy-popup').fadeOut();
        });
    },
    openPrevent: function() {
        $('html').addClass('prevent-box');
    },
    closePrevent: function() {
        $('html').removeClass('prevent-box');
    },
    // 阿里云埋点
    countNum: function(data) {
        setTimeout(() => {
            try {
                __bl.sum(data);
            } catch (e) {
                // console.log(e)
            }
        }, 500);
    }
}